module.exports = __webpack_public_path__ + "9f013b0c534f42ad08f6e9289f6f18fe.svg";